const dataURLToBlob = (dataURL: string) => {
    const BASE64_MARKER = ';base64,'
    if (dataURL.indexOf(BASE64_MARKER) === -1) {
        const parts = dataURL.split(',')
        const contentType = parts[0].split(':')[1]
        const raw = parts[1]

        return new Blob([raw], { type: contentType })
    }

    const parts = dataURL.split(BASE64_MARKER)
    const contentType = parts[0].split(':')[1]
    const raw = window.atob(parts[1])
    const rawLength = raw.length

    const uInt8Array = new Uint8Array(rawLength)

    for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
    }

    return new Blob([uInt8Array], { type: contentType })
}

/**
 * Resize the image if it's bigger than the given dimension (width x height).
 * The resized image should have the same ratio with the source image.
 *
 * @param imageFile the file of image to resize
 * @param maxWidth the max width
 * @param maxHeight the max height
 */
export const resizeImage = (imageFile: File, { maxWidth, maxHeight }) => new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (readerEvent) => {
        const image = new Image()
        image.onload = () => {
            // Resize the image
            const canvas = document.createElement('canvas')
            let width = image.width
            let height = image.height
            let ratio = 0 // Used for aspect ratio

            if (width > maxWidth) {
                ratio = maxWidth / width
                height *= ratio
                width *= ratio
            }
            if (height > maxHeight) {
                ratio = maxHeight / height
                width *= ratio
                height *= ratio
            }
            canvas.width = width
            canvas.height = height
            canvas.getContext('2d').drawImage(image, 0, 0, width, height)
            const dataUrl = canvas.toDataURL(imageFile.type)
            const resizedImage = dataURLToBlob(dataUrl)
            const resizedFile = new File([resizedImage], imageFile.name,
                { type: imageFile.type, lastModified: new Date().getTime() })
            resolve(resizedFile)
        }
        image.onabort = reject
        image.onerror = reject
        image.src = readerEvent.target.result as string
    }
    reader.onabort = reject
    reader.onerror = reject
    reader.readAsDataURL(imageFile)
})
